export const registerFormConstraints = (translateKey2: string, translateKey3: string, translateKey4: string, keyPidFormat: string, pidPattern: RegExp): { [key: string]: any } => {
  return {
    pid: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: pidPattern,
        flags: 'i',
        message: keyPidFormat
      },
    },
    accountNumber: {
      presence: {
        allowEmpty: false,
      },
    },
    firstName: {
      presence: {
        allowEmpty: false,
      },
    },

    lastName: {
      presence: {
        allowEmpty: false,
      },
    },

    password: {
      length: {
        minimum: 8,
        message: translateKey2,
      },
    },

    repeatPassword: {
      equality: {
        attribute: 'password',
        message: translateKey3,
      },
    },

    agreement: {
      presence: {
        message: translateKey4,
      },
    },
  };
};